<template>
  <div
    class="check-table-header"
    :style="{
      '--division': division
    }"
  >
    <div v-for="i in division" :key="`check_table_header_${i}`" class="header-type-fire-fighting">
      <div class="item A"><span>{{ title }}</span></div>
      <div class="item B"><span>점검결과</span></div>
      <div class="item B1"><span>보수<br />필요</span></div>
      <div class="item B2"><span>점검자 의견</span></div>
      <div class="item C"><span>평가결과</span></div>
      <div class="item C1"><span class="text-center">우수<br />(10)</span></div>
      <div class="item C2"><span class="text-center">양호<br />(8)</span></div>
      <div class="item C3"><span class="text-center">보통<br />(5)</span></div>
      <div class="item C4"><span class="text-center">미흡<br />(2)</span></div>
      <div class="item C5"><span class="text-center">해당<br />없음</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckTableHeader',
  props: {
    title: String,
    division: { type: Number, default: () => { return 1 }},
  },

}
</script>

<style lang="scss" scoped>
.check-table-header {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(var(--division), 1fr);
}
.item {
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 50px;

  border-bottom: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}
.header-type-fire-fighting {
  display: grid;
  grid-template-columns: 1fr 50px 200px 50px 50px 50px 50px 50px;
  grid-template-areas:
    "A B  B  C  C  C  C  C "
    "A B1 B2 C1 C2 C3 C4 C5";

  .A { height: 100%; grid-area: A; }
  .B { height: 100%; grid-area: B; }
  .B1 { height: 100%; grid-area: B1; }
  .B2 { height: 100%; grid-area: B2; }
  .C { height: 100%; grid-area: C; }
  .C1 { height: 100%; grid-area: C1; }
  .C2 { height: 100%; grid-area: C2; }
  .C3 { height: 100%; grid-area: C3; }
  .C4 { height: 100%; grid-area: C4; }
  .C5 { height: 100%; grid-area: C5; }
}
</style>
